import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  template: `<div class="layout-footer">
    <div class="flex justify-content-center">
      Copyright © 2026 GIP. All rights reserved.
    </div>
  </div>`,
  styles: [
    `
      .layout-footer {
        background: #FFFFFF;
        height: 43.25px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #334155;
        font-weight: 600;
      }
    `,
  ],
})
export class AppFooterComponent {}
